
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 107","d":"M28 0H4a4 4 0 00-4 4v16a4 4 0 004 4h24a4 4 0 004-4V4a4 4 0 00-4-4z","fill":"#27337a"}}),_c('path',{attrs:{"data-name":"Path 108","d":"M16.309 10.918c-.01.836.722 1.3 1.273 1.579s.757.467.755.721c0 .389-.452.561-.871.568a2.964 2.964 0 01-1.493-.367l-.264 1.273a4.26 4.26 0 001.617.308c1.528 0 2.527-.778 2.532-1.985.006-1.532-2.052-1.616-2.038-2.3 0-.208.2-.429.617-.485a2.661 2.661 0 011.434.259l.256-1.23A3.791 3.791 0 0018.766 9c-1.437 0-2.449.789-2.457 1.918zm6.275-1.812a.663.663 0 00-.619.426l-2.182 5.378h1.526l.3-.866h1.865l.176.866H25l-1.174-5.8zm.216 1.568l.44 2.179h-1.209zm-8.342-1.568l-1.2 5.8h1.452l1.2-5.8zm-2.152 0l-1.513 3.95L10.18 9.7a.684.684 0 00-.671-.591H7.035L7 9.274a5.926 5.926 0 011.435.494.635.635 0 01.345.51l1.16 4.632h1.538l2.357-5.8z","fill":"#fff"}})])
          )
        }
      }
    